import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get loyalty customer count
  getLoyaltyCustomerCount(token: string, retailerId: any, startDate: any, endDate: any){
    const URL = environment.apiUrl + 'dashboard/loyaltyCustomerCount';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('start_date', startDate)
      .set('end_date', endDate);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Get loyalty customer sales
  getLoyaltyCustomerSales(token: string, retailerId: any, startDate: any, endDate: any){
    const URL = environment.apiUrl + 'dashboard/loyaltyCustomerSales';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('start_date', startDate)
      .set('end_date', endDate);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }
  
  
  
  
  // OLD - NOT USED NOW =====================================================================
  // Get loyalty settings
  getLoyaltySettings(token: string, retailerId: any){
    const URL = environment.apiUrl + 'dashboard/loyaltySettings';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Manage(Add/Edit) loyalty settings
  manageLoyaltySettings (token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/manageLoyaltySettings ';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get loyalty customer list
  getLoyaltyCustomerList(token: string, retailerId: any, storeId: any, page: any, pageSize: any, sortField : any, sorttype : any){
    const URL = environment.apiUrl + 'dashboard/loyaltyCustomerList';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('store_id', storeId)
      .set('page', page)
      .set('page_size', pageSize)
      .set('sort_field', sortField)
      .set('sort_type', sorttype);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

}
